import colors from "../../base/colors";
import pxToRem from "../../functions/pxToRem";
import rgba from "../../functions/rgba";

const { text, grey, primary, background } = colors;

const autocomplete = {
  defaultProps: {
    autoHighlight: true,
    clearOnEscape: true,
  },
  styleOverrides: {
    root: {
      "& .MuiOutlinedInput-root": {
        paddingTop: pxToRem(3),
        paddingBottom: pxToRem(3),
        paddingLeft: pxToRem(6),
      },
    },

    popper: {
      boxShadow: "0 8px 24px rgba(0,0,0,0.45)",
      padding: 0,
      fontSize: pxToRem(14),
      color: text.main,
      textAlign: "left" as const,
      backgroundColor: `${background.card} !important`,
      borderRadius: pxToRem(4),
    },

    paper: {
      boxShadow: "none",
      backgroundColor: background.card,
      border: `1px solid ${grey[700]}`,
      borderRadius: pxToRem(4),
    },

    listbox: {
      padding: pxToRem(4),
    },

    option: {
      minHeight: pxToRem(32),
      padding: `${pxToRem(6)} ${pxToRem(8)}`,
      borderRadius: pxToRem(4),
      fontSize: pxToRem(14),
      color: text.main,
      transition: "background-color 80ms ease",

      "&:hover, &:focus": {
        backgroundColor: rgba(text.main, 0.08),
      },

      "&.Mui-focused": {
        backgroundColor: rgba(text.main, 0.08),
      },

      '&[aria-selected="true"]': {
        backgroundColor: `${rgba(primary.main, 0.18)} !important`,
        color: `${text.main} !important`,
      },
    },

    noOptions: {
      fontSize: pxToRem(14),
      color: text.main,
      padding: `${pxToRem(8)} ${pxToRem(10)}`,
    },

    groupLabel: {
      color: text.main,
      fontSize: pxToRem(12),
      fontWeight: 600,
      lineHeight: pxToRem(32),
    },

    loading: {
      fontSize: pxToRem(14),
      color: text.main,
    },

    tag: {
      display: "flex" as const,
      alignItems: "center" as const,
      height: pxToRem(20),
      margin: pxToRem(2),
      backgroundColor: grey[800],
      color: text.main,
      borderRadius: pxToRem(2),

      "& .MuiChip-label": {
        lineHeight: 1.2,
        padding: `0 ${pxToRem(8)}`,
        fontSize: pxToRem(12),
      },
    },

    popupIndicator: {
      color: text.main,
      width: pxToRem(24),
      height: pxToRem(24),
    },

    clearIndicator: {
      color: text.main,
      width: pxToRem(20),
      height: pxToRem(20),
    },

    endAdornment: {
      right: pxToRem(6),
    },
  },
};

export default autocomplete;
